module.exports = __webpack_public_path__ + "static/media/event.73e8c9bf.png";